
export function screenResize () {
  const screenWidth = window.screen.width
  console.log('now window size :', screenWidth)
  if (screenWidth < 1920) {
    const zoomRate = screenWidth / 1920
    document.body.style.zoom = zoomRate
    console.log('zoom ', zoomRate)
  } else {
    console.log('no need zoom')
  }
}



// WEBPACK FOOTER //
// ./src/lib/screenResize.js